let activeItem = null;

document.querySelectorAll('.product-accordion-info .accordion-header').forEach(button => {
  button.addEventListener('click', () => {
    const item = button.closest('.accordion-item');
    const isActive = item === activeItem;

    // Close all open items
    if(activeItem) {
      activeItem.classList.remove('active');
      activeItem.querySelector('.accordion-header').setAttribute('aria-expanded', 'false');
      activeItem.querySelector('.accordion-content').style.display = 'none';
    }

    // Open clicked item if it wasn't already open
    if (!isActive) {
      item.classList.add('active');
      button.setAttribute('aria-expanded', 'true');
      item.querySelector('.accordion-content').style.display = 'block';
      activeItem = item;
    }else {
      activeItem = null;
    }
  });
});

// Open first item on load
const firstItem = document.querySelector('.product-accordion-info .accordion-item');
if (firstItem) {
  firstItem.classList.add('active');
  firstItem.querySelector('.accordion-header').setAttribute('aria-expanded', 'true');
  firstItem.querySelector('.accordion-content').style.display = 'block';
  activeItem = firstItem;
}